import { RemoveComponent } from '../../app-lite/table/cell-components/actions/remove.component';

export function CeleroTerminalsCtrl (
  $state,
  $scope,
  $translate,
  Celero,
  confirm,
  messages,
  tableApi,
  workshopAPI
) {
  $scope.celero              = new Celero();
  $scope.showCeleroTerminals = !!$scope.terminals.length;
  $scope.tableCacheKey       = 'posTerminal';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'pos_terminal_name',
        header: {
          text: 'Name'
        }
      },
      {
        classes: 'text-center',
        field  : 'tnp_public_key',
        header : {
          classes: 'text-center',
          text   : 'Serial Number'
        }
      },
      {
        classes: 'text-center',
        field  : 'tnp_terminal_id',
        header : {
          classes: 'text-center',
          text   : 'Terminal ID'
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onRemoveClick: event => $scope.removeItem(event)
            }
          },
          enabled: true,
          factory: RemoveComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TERMINALS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/pos_terminals/tnp_terminal_count')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'terminal_name'
    })
  };

  $scope.getTerminals = ( params ) => {
    return workshopAPI.get('/pos_terminals/tnp_terminal_list', [
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
    ]).then(terminals => {
      $scope.terminals = terminals;

      return terminals;
    });
  };

  $scope.removeItem = function (row) {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_TERMINAL'))
    .then(() =>  $scope.celero.deleteTerminal(row))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.TERMINAL'), 'success');

      $state.reload();
    });
  };
}
